/**
 * Fibra a mais valida a meta de Renovação (Douglas 26/10/2026, maquete aprovada).
 *
 * "Se eles não baterem a meta de renovação, para suprir basta fazer mais 2
 * fibras sobre a meta de fibra... caso o consultor tenha estorno, é a meta, o
 * estorno e mais 2."
 *
 * Quem bateu a Renovação segue igual. Quem não bateu tem a Renovação validada
 * quando as fibras ativadas chegam à meta de fibra + `meta_fibras_renovacao`.
 * As fibras chegam líquidas (o estorno já entra negativo), então "meta +
 * estorno + 2" sai sozinho. Vale só para a Renovação e só valida a meta: não
 * paga nada a mais. No gestor (supervisor, coordenador, gerente) o adicional é
 * por consultor que conta no N (Douglas 29/10/2026: "todos os supervisores e
 * gerente teriam este adicional de 2 fibra por cada consultor válido pra
 * meta"): alvo de fibra da equipe + número da linha × N.
 *
 * Régua única dos três motores (tela, folha e Excel).
 */
export interface MetaFibrasRenovacao {
  meta_fibras_renovacao?: number | null;
  usar_meta_fibras_renovacao?: boolean | null;
}

export function renovacaoBatidaPorFibra(p: {
  renovacao: number;
  metaRenovacao: number;
  fibras: number;
  metaFibras: number;
  regra: MetaFibrasRenovacao | null | undefined;
  n?: number;
}): boolean {
  if (!p.regra?.usar_meta_fibras_renovacao) return false;
  if (p.renovacao >= p.metaRenovacao) return false;
  const n = Math.max(1, Number(p.n ?? 1));
  const aMais = Math.max(0, Number(p.regra.meta_fibras_renovacao ?? 0)) * n;
  return p.fibras >= p.metaFibras + aMais;
}

/** Renovação conta como batida: meta desligada, bateu, ou validada por fibra. */
export function renovacaoOk(p: {
  usar: boolean;
  renovacao: number;
  metaRenovacao: number;
  fibras: number;
  metaFibras: number;
  regra: MetaFibrasRenovacao | null | undefined;
  n?: number;
}): boolean {
  if (!p.usar || p.renovacao >= p.metaRenovacao) return true;
  return renovacaoBatidaPorFibra(p);
}
